import React, { Component } from 'react'

class AddExams extends Component {
    render() {
        return (
            <div style={{ padding: "10px" }}>

                <form className="was-validated">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card">
                                <div className="card-header bg-primary" style={{ color: "white" }}>Add Exam Information</div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="form-group col-lg-6">
                                            <label for="fname"><b>Exam Name</b></label>
                                            <input type="text" class="form-control" id="uname" placeholder="Exam Name"
                                                name="fname" required />
                                            <div class="valid-feedback">Valid.</div>
                                            <div class="invalid-feedback">Please fill out this field.</div>
                                        </div>
                                        <div className="form-group col-lg-6">
                                            <label for="lname"><b>Exam Subject</b></label>
                                            <input type="text" class="form-control" id="pwd" placeholder="Exam Subject"
                                                name="lname" required />
                                            <div class="valid-feedback">Valid.</div>
                                            <div class="invalid-feedback">Please fill out this field.</div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="form-group col-lg-6">
                                            <label for="fname"><b>Class</b></label>
                                            <select class="form-control">
                                                <option>Std 1</option>
                                                <option>Std 2</option>
                                                <option>Std 3</option>
                                                <option>Std 4</option>
                                            </select>
                                            <div class="valid-feedback">Valid.</div>
                                            <div class="invalid-feedback">Please fill out this field.</div>
                                        </div>
                                        <div className="form-group col-lg-6">
                                            <label for="lname"><b>Type</b></label>
                                            {/* <input type="text" class="form-control" id="pwd" placeholder="Class Teacher"
                                                name="lname" required /> */}
                                            <select class="form-control">
                                                <option>Annual</option>
                                                <option>Half Yearly</option>
                                                <option>Monthly</option>
                                                <option>Weekly</option>
                                            </select>
                                            <div class="valid-feedback">Valid.</div>
                                            <div class="invalid-feedback">Please fill out this field.</div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="form-group col-lg-6">
                                            <label for="fname"><b>Date</b></label>
                                            <input type="date" class="form-control" id="uname"
                                                name="fname" required />
                                            <div class="valid-feedback">Valid.</div>
                                            <div class="invalid-feedback">Please fill out this field.</div>
                                        </div>
                                        <div className="form-group col-lg-6">
                                            <label for="lname"><b>Timing</b></label>
                                            <input type="date" class="form-control" id="pwd" placeholder="Shift Timing"
                                                name="lname" required />
                                            <div class="valid-feedback">Valid.</div>
                                            <div class="invalid-feedback">Please fill out this field.</div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="form-group col-lg-6">
                                            <label for="fname"><b>Incharge</b></label>
                                            <input type="text" class="form-control" id="uname" placeholder="Incharge Name"
                                                name="fname" required />
                                            <div class="valid-feedback">Valid.</div>
                                            <div class="invalid-feedback">Please fill out this field.</div>
                                        </div>

                                    </div>

                                    {/* <div class="row">
                                        <div class="col-lg-12 " style={{ textAlign: "end" }}>
                                            <button type="submit" class="btn btn-primary">Submit</button>
                                            <button type="reset" class="btn btn-success">Reset</button>
                                            <button class="btn btn-primary">Back</button>
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </form>

            </div>
        );
    }
}

export default AddExams;